module.exports = __webpack_public_path__ + "static/img/interaction1.1824ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/interaction1.png
// module id = d0vg
// module chunks = 3